import { Alert } from "@material-ui/lab";

export type { AlertProps } from "@material-ui/lab";
export { AlertTitle } from "@material-ui/lab";
export default Alert;
